import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Spinner from 'react-bootstrap/esm/Spinner';
import { useParams } from 'react-router-dom';
import { getRegistrations, updateRaceClass } from '../api/Registrations';
import { raceClassesObj } from '../utils/CheckEligibleRaceClasses';
function RaceClassDropdown({
  value,
  status,
  setRegistrations,
  participantId = null,
  email = null,
  disabled,
}) {
  const [updating, setUpdating] = useState(false);
  const { id: competitionId } = useParams();

  async function updateParticipantRaceClass(raceClass) {
    setUpdating(true);

    // If participantId exists - only use that and set email to empty array
    if (participantId) {
      email = [];
      participantId = [participantId];
    }

    // Vice versa for email without any participantId
    if (email && !participantId) {
      participantId = [];
      email = [email];
    }

    const result = await updateRaceClass(
      competitionId,
      raceClass,
      participantId,
      email
    );

    if (result.statusCode === 200) {
      setRegistrations(result.registrations);
    }

    setUpdating(false);
  }

  if (status !== 'Kommande') {
    disabled = true;
  }

  return (
    <>
      {value === 'Junior' || value === 'junior' ? (
        <Dropdown id="dropdown-basic-button" size="sm" disabled={updating}>
          <Dropdown.Toggle
            as="div"
            variant="secondary-black"
            className="p-2 bg-info"
            style={{
              fontSize: '16px',
              lineHeight: '16px',
              userSelect: 'none',
            }}
          >
            Junior{' '}
          </Dropdown.Toggle>
        </Dropdown>
      ) : (
        <Dropdown id="dropdown-basic-button" size="sm" disabled={updating}>
          <Dropdown.Toggle
            as="div"
            variant="secondary-black"
            className="p-2 bg-info"
            style={{
              fontSize: '16px',
              lineHeight: '16px',
              cursor: 'pointer',
            }}
          >
            {updating ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                <span className="visually-hidden">Loading...</span>
              </>
            ) : (
              <>
                {value === 'women'
                  ? 'Dam '
                  : value.charAt(0).toUpperCase() + value.slice(1) + ' '}
              </>
            )}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {Object.values(raceClassesObj).map((rc) => {
              return (
                <Dropdown.Item
                  key={rc.id}
                  onClick={() => {
                    updateParticipantRaceClass(rc.id);
                  }}
                  disabled={disabled}
                >
                  {rc.label}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}

export default RaceClassDropdown;
